import { __rest as e } from "tslib";
import * as r from "react";
import t from "classnames";
import { ComponentClassNames as s } from "../shared/constants.js";
import "../Field/FieldClearButton.js";
import { FieldDescription as i } from "../Field/FieldDescription.js";
import { FieldErrorMessage as l } from "../Field/FieldErrorMessage.js";
import { Flex as o } from "../Flex/Flex.js";
import { Label as a } from "../Label/Label.js";
import { Select as d } from "../Select/Select.js";
import { splitPrimitiveProps as n } from "../shared/styleUtils.js";
import { useStableId as m } from "../utils/useStableId.js";
var c = r.forwardRef(function (c, p) {
  var f = c.children,
    h = c.className,
    b = c.descriptiveText,
    F = c.errorMessage,
    _c$hasError = c.hasError,
    j = _c$hasError === void 0 ? !1 : _c$hasError,
    E = c.id,
    u = c.label,
    _c$labelHidden = c.labelHidden,
    g = _c$labelHidden === void 0 ? !1 : _c$labelHidden,
    v = c.options,
    y = c.size,
    S = c.testId,
    x = e(c, ["children", "className", "descriptiveText", "errorMessage", "hasError", "id", "label", "labelHidden", "options", "size", "testId"]),
    I = m(E),
    z = m(),
    H = b ? z : void 0,
    _n = n(x),
    M = _n.flexContainerStyleProps,
    N = _n.baseStyleProps,
    T = _n.rest;
  return r.createElement(o, Object.assign({
    className: t(s.Field, s.SelectField, h),
    "data-size": y,
    testId: S
  }, N, M), r.createElement(a, {
    htmlFor: I,
    visuallyHidden: g
  }, u), r.createElement(i, {
    id: z,
    labelHidden: g,
    descriptiveText: b
  }), r.createElement(d, Object.assign({
    "aria-describedby": H,
    hasError: j,
    id: I,
    ref: p,
    size: y
  }, T), function (_ref) {
    var e = _ref.children,
      t = _ref.options;
    return e ? ((null == t ? void 0 : t.length) && console.warn("Amplify UI: <SelectField> component  defaults to rendering children over `options`. When using the `options` prop, omit children."), e) : null == t ? void 0 : t.map(function (e, t) {
      return r.createElement("option", {
        label: e,
        value: e,
        key: "".concat(e, "-").concat(t)
      }, e);
    });
  }({
    children: f,
    options: v
  })), r.createElement(l, {
    hasError: j,
    errorMessage: F
  }));
});
c.displayName = "SelectField";
export { c as SelectField };